function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 33,
  height: 23,
  rx: 3.5,
  fill: "white",
  stroke: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.7503 15.8582H8.69051L7.14596 9.79235C7.07265 9.51332 6.91699 9.26664 6.68802 9.15038C6.11659 8.85821 5.48692 8.62568 4.8 8.50841V8.27487H8.11808C8.57603 8.27487 8.91948 8.62568 8.97673 9.0331L9.77813 13.4086L11.8369 8.27487H13.8394L10.7503 15.8582ZM14.9842 15.8582H13.039L14.6408 8.27487H16.586L14.9842 15.8582ZM19.1027 10.3757C19.1599 9.96725 19.5034 9.73372 19.9041 9.73372C20.5338 9.67508 21.2197 9.79235 21.7921 10.0835L22.1356 8.45079C21.5631 8.21725 20.9335 8.09998 20.362 8.09998C18.474 8.09998 17.1002 9.15038 17.1002 10.6082C17.1002 11.7173 18.0733 12.2996 18.7603 12.6504C19.5034 13.0002 19.7896 13.2337 19.7324 13.5835C19.7324 14.1082 19.1599 14.3418 18.5885 14.3418C17.9016 14.3418 17.2147 14.1669 16.586 13.8747L16.2426 15.5084C16.9295 15.7996 17.6726 15.9169 18.3596 15.9169C20.4765 15.9745 21.7921 14.9251 21.7921 13.35C21.7921 11.3664 19.1027 11.2502 19.1027 10.3757ZM28.6 15.8582L27.0554 8.27487H25.3964C25.0529 8.27487 24.7095 8.50841 24.595 8.85821L21.7349 15.8582H23.7374L24.1371 14.7502H26.5975L26.8265 15.8582H28.6ZM25.6826 10.3171L26.254 13.1751H24.6523L25.6826 10.3171Z",
  fill: "#172B85"
});

var SvgVisa = function SvgVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Visa.5ccd4eef.svg";
export { ForwardRef as ReactComponent };